<template>
  <b-container fluid>
    <page-title icon="fas fa-user-tie">
      <translate>Customers</translate>
      <template #extras>
        <b-button variant="secondary" size="sm" :to="{name: 'CustomersCreate'}">
          <font-awesome-icon icon="plus-circle" />
          <translate>New Customer</translate>
        </b-button>
      </template>
    </page-title>
    <api-list type="customers" :model="models.customers" :quick-filters="quickFiltersSetup.companies" :pre-filters="[['relationship', 'eq', 'client']]" />
  </b-container>
</template>
<script>
import ApiList from '@/components/ApiLists/ApiList'

export default {
  name: 'CustomerList',
  title() {
    return this.$gettext('Customers')
  },
  components: {
    ApiList
  }
}
</script>
